export default __webpack_public_path__ + "media/images/icons_fc/group-c2456361b5134a574f11dccbed63c278.png";